export const FETCH_WHOIS_REQUEST = 'FETCH_WHOIS_REQUEST';
export const FETCH_WHOIS_SUCCESS = 'FETCH_WHOIS_SUCCESS';
export const FETCH_WHOIS_FAILURE = 'FETCH_WHOIS_FAILURE';
